import { apiFetch } from '../utils/api';

export interface Employee {
  id: string;
  erpId: string;
  username: string;
  employeeId: number | null;
  staffId: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  mobileNumber: string | null;
  homeContact: string | null;
  photo: string | null;
  typeKey: string | null;
  locations?: Array<{ id: number; name: string }>; // empty array => all locations
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedEmployeesResponse {
  data: Employee[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface FetchEmployeesParams {
  page?: number;
  limit?: number;
  search?: string;
  locationId?: string | number;
  role?:
  | 'COMPANY_OWNER'
  | 'STORE_MANAGER'
  | 'RETAIL_PLANNER'
  | 'MASTER'
  | 'WAREHOUSE_MANAGER'
  | 'DIRECTOR'
  | 'TECHNICIAN'
  | 'ADVISOR'
  | 'ADMIN';
}

export const fetchEmployees = (
  params: FetchEmployeesParams = {},
): Promise<PaginatedEmployeesResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  if (params.locationId) {
    searchParams.set('locationId', String(params.locationId));
  }

  if (params.role) {
    searchParams.set('role', params.role);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedEmployeesResponse>(
    `/users${query ? `?${query}` : ''}`,
  );
};

export const fetchEmployee = (id: string) =>
  apiFetch<Employee>(`/users/${id}`);
